import React from "react";
import { FileCard } from "components/RFQ/FileCard";
import { FileUpload } from "components/RFQ/FileUpload";
import LabelForm from "components/RFQ/LabelForm/LabelForm";
import { getFileNameFromUrl, getOriginalFileName } from "utils/helpers";
import { convertToFileUploadFormat, deleteFile } from "helpers/fileHelper";
import { FILE_UPLOAD_TYPES, fileUpload } from "newui/components/FileUpload";

export default function QuoteFile({
	quoteFilepath,
	companyName,
	rfxId,
	rfxInviteId,
	disabled,
	submissionQuoteFiles,
	isPreview = false,
}) {
	// Extract original filename from the S3 URL
	const serverFileName = getFileNameFromUrl(quoteFilepath);
	const originalFileName = getOriginalFileName(serverFileName);

	const fileData = {
		name: originalFileName || "Quote template.xlsx",
		path: quoteFilepath,
		description: `${companyName} has submitted a quote template. Please download this template and upload your response below.`,
	};

	const previewQuoteFileData = convertToFileUploadFormat(submissionQuoteFiles);

	const onDeleteFile = async (file) => {
		return fileUpload.util.deleteFileUpload(
			file,
			FILE_UPLOAD_TYPES.QUOTE_FILE_RESPONSE
		);
	};

	return (
		<>
			<LabelForm label="Download quotation template" />
			<FileCard
				file={fileData}
				isPreview
			/>

			<FileUpload
				type="file"
				label="Attach quote response"
				name="quote_files"
				className="my-4 w-full"
				types={["xlsx", "xls", "csv"]}
				required
				multiple={true}
				maxFileSize={100}
				disabled={disabled}
				hideUploadField={disabled && !isPreview}
				existingFiles={previewQuoteFileData}
				fileExtraData={{
					model: FILE_UPLOAD_TYPES.QUOTE_FILE_RESPONSE,
					rfq_id: rfxId,
					rfxInviteId: rfxInviteId,
				}}
				testId="quote-file-upload"
				onDelete={onDeleteFile}
			/>
		</>
	);
}
